"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_dom_1 = __importDefault(require("react-dom"));
const Portal = ({ children, container, disablePortal }) => {
    const [parentNode, setParentNode] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        if (!disablePortal) {
            setParentNode((typeof container === 'function' ? container() : container) || document.body);
        }
    }, [container]);
    if (disablePortal)
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children });
    return parentNode ? react_dom_1.default.createPortal(children, parentNode) : null;
};
exports.default = Portal;
